// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let Tooltip = require("../../reason/common/Tooltip.bs.js");
let ViewStack = require("../../reason/common/ViewStack.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let UseShouldShowPropertyDetails = require("../common/Hooks/UseShouldShowPropertyDetails.bs.js");
let PropertyLocationForCard_propertyV5_graphql = require("../../__generated__/PropertyLocationForCard_propertyV5_graphql.bs.js");

let convertFragment = PropertyLocationForCard_propertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyLocationForCard_propertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyLocationForCard_propertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyLocationForCard_propertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyLocationForCard_propertyV5_graphql.node, convertFragment, fRef);
}

let PropertyFragment_visibilityReason_decode = PropertyLocationForCard_propertyV5_graphql.Utils.visibilityReason_decode;

let PropertyFragment_visibilityReason_fromString = PropertyLocationForCard_propertyV5_graphql.Utils.visibilityReason_fromString;

let PropertyFragment = {
  visibilityReason_decode: PropertyFragment_visibilityReason_decode,
  visibilityReason_fromString: PropertyFragment_visibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyLocationForCard(props) {
  let property = RescriptRelay_Fragment.useFragment(PropertyLocationForCard_propertyV5_graphql.node, convertFragment, props.property);
  let shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(property.fragmentRefs);
  let headingClassName = TailwindMerge.twMerge([
    "text-zinc-700 text-lg font-medium leading-tight",
    Stdlib_Option.getOr(props.className, "")
  ]);
  let match = property.propertyLocation;
  let tmp;
  if (shouldShowPropertyDetails) {
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("h3", {
              children: match.locationDisplay,
              className: headingClassName
            }),
            JsxRuntime.jsxs(ViewStack.make, {
              space: "xs",
              alignItems: "center",
              flexDirection: "row",
              children: [
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(IconV5.make, {
                    icon: "lock",
                    className: "text-tan-gold-light"
                  })
                }),
                JsxRuntime.jsx("div", {
                  children: "Contact agent for address",
                  className: "text-zinc-600 text-lg font-normal"
                })
              ]
            })
          ]
        });
        break;
      case "PropertyLocationWithVisibleAddress" :
        let locationDisplay = match.locationDisplay;
        let address = match.address;
        let exit = 0;
        let tmp$1 = match.visibilityRule;
        if (tmp$1 === "VISIBLE_TO_ACCOUNT_MEMBER") {
          tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx("h3", {
                children: locationDisplay,
                className: headingClassName
              }),
              JsxRuntime.jsxs(ViewStack.make, {
                space: "xs",
                alignItems: "center",
                flexDirection: "row",
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(IconV5.make, {
                      icon: "lock",
                      className: "text-tan-gold-light"
                    })
                  }),
                  JsxRuntime.jsx(Tooltip.make, {
                    ariaLabel: address + ` (only visible to you)`,
                    label: address,
                    children: JsxRuntime.jsx("div", {
                      children: "Hidden Address",
                      className: "text-zinc-600 text-lg font-normal relative underline decoration-dotted"
                    })
                  })
                ]
              })
            ]
          });
        } else {
          exit = 1;
        }
        if (exit === 1) {
          tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx("h3", {
                children: locationDisplay,
                className: headingClassName
              }),
              JsxRuntime.jsx("div", {
                children: address,
                className: "text-zinc-600 text-lg font-normal"
              })
            ]
          });
        }
        break;
      case "__unselected" :
        tmp = UnselectedUnionMemberError.raise(match._0);
        break;
    }
  } else {
    let exit$1 = 0;
    let locationDisplay$1;
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        locationDisplay$1 = match.locationDisplay;
        exit$1 = 1;
        break;
      case "PropertyLocationWithVisibleAddress" :
        locationDisplay$1 = match.locationDisplay;
        exit$1 = 1;
        break;
      case "__unselected" :
        tmp = UnselectedUnionMemberError.raise(match._0);
        break;
    }
    if (exit$1 === 1) {
      tmp = JsxRuntime.jsx("h3", {
        children: locationDisplay$1,
        className: headingClassName
      });
    }
  }
  return JsxRuntime.jsx(ViewStack.make, {
    space: "xs",
    children: tmp
  });
}

let make = PropertyLocationForCard;

exports.PropertyFragment = PropertyFragment;
exports.make = make;
/* IconV5 Not a pure module */
